import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { InsightBar } from '../../components/charts/InsightBar.jsx';
import { useChartPalette } from '../../components/charts/useChartPalette.js';
import { Skeleton } from '../../components/ui/Skeleton.jsx';
import { useTranslation } from '../../i18n/useTranslation.js';
import { productionApi } from '../../services/productionApi.js';
import { formatCurrency } from '../../utils/formatters.js';

/* COMPLETING gehoert dazwischen: angestossen, aber noch nicht gebucht. Fehlte
   er hier, verschwaenden solche Auftraege aus der Uebersicht - und das waere
   wieder genau die Sorte Luecke, die dieses Paket schliesst. */
const STATUS_ORDER = ['DRAFT', 'RELEASED', 'IN_PROGRESS', 'COMPLETING', 'COMPLETED', 'CANCELLED'];

function statusColor(palette, status) {
  if (status === 'DRAFT') return palette?.axis;
  if (status === 'RELEASED') return palette?.series?.[4];
  if (status === 'IN_PROGRESS') return palette?.series?.[2];
  if (status === 'COMPLETING') return palette?.series?.[3];
  if (status === 'COMPLETED') return palette?.series?.[0];
  return palette?.series?.[3];
}

export function ProductionDashboardPage() {
  const { t } = useTranslation();
  const palette = useChartPalette();

  const insights = useQuery({ queryKey: ['production', 'insights'], queryFn: () => productionApi.insights().then((r) => r.items) });
  const status = useQuery({ queryKey: ['production', 'wo-status'], queryFn: () => productionApi.workOrderStatus().then((r) => r.items) });

  const statusRows = useMemo(() => {
    const list = status.data?.statuses || [];
    const byStatus = new Map(list.map((s) => [s.status, s]));
    return STATUS_ORDER.map((s) => ({ status: s, count: byStatus.get(s)?.count ?? 0 }));
  }, [status.data]);

  const ins = insights.data || {};
  const loading = insights.isLoading || status.isLoading;

  return (
    <section className="page">
      <header className="page-header">
        <div>
          <h1>{t('production.dashboard.title')}</h1>
          <p className="muted">{t('production.dashboard.subtitle')}</p>
        </div>
      </header>

      {loading ? (
        <Skeleton variant="cards" count={4} />
      ) : (
        <InsightBar
          title={t('insight.byStatus')}
          labels={statusRows.map((s) => t(`production.status.${s.status}`))}
          values={statusRows.map((s) => s.count)}
          colors={statusRows.map((s) => statusColor(palette, s.status))}
          metrics={[
            { label: t('production.metric.active'), value: ins.active ?? 0 },
            { label: t('production.metric.draft'), value: ins.draft ?? 0 },
            { label: t('production.metric.completed'), value: ins.completed ?? 0 },
            { label: t('production.metric.completedValue'), value: formatCurrency(ins.completedValue ?? 0) },
          ]}
        />
      )}
    </section>
  );
}
